import React from 'react';
import { useNotificationContext } from '../../context/NotificationContext';
import { BadgeContainer, Badge } from './styles';

/**
 * MessageBadge - Shows total unread message count with real-time updates
 * Uses shared NotificationContext to access totalUnreadMessages
 */
const MessageBadge = ({ children }) => {
  const { totalUnreadMessages } = useNotificationContext();

  return (
    <BadgeContainer>
      {children}
      {totalUnreadMessages > 0 && (
        <Badge>{totalUnreadMessages > 99 ? '99+' : totalUnreadMessages}</Badge>
      )}
    </BadgeContainer>
  );
};

export default MessageBadge;
